module.exports = __webpack_public_path__ + "img/rlBanner-zh.9ba0f890.png";